<template>
    <div class="tw-border tw-border-2 tw-p-4 tw-rounded-lg">
        <component
            :is="collapsible ? 'button' : 'div'"
            v-if="title || subtext || collapsible"
            class="tw-flex tw-w-full tw-items-center tw-justify-between tw-border-0 tw-bg-transparent tw-p-0 tw-text-left"
            :class="[headerClass, { 'tw-cursor-pointer': collapsible }]"
            :type="collapsible ? 'button' : undefined"
            :aria-expanded="collapsible ? isOpen : undefined"
            @click="toggle"
        >
            <div class="tw-flex tw-flex-col">
                <span v-if="title" class="tw-col-span-2 tw-font-medium">{{ title }}</span>
                <span v-if="subtext" class="tw-text-gray-400">{{ subtext }}</span>
            </div>
            <i
                v-if="collapsible"
                class="mdi mdi-chevron-down tw-block tw-scale-[1.75] tw-transition-transform tw-duration-200"
                :class="{ 'tw-rotate-180': isOpen }"
            ></i>
        </component>
        <Transition
            enter-active-class="tw-transition-all tw-duration-200 tw-ease-out motion-reduce:tw-transition-none"
            enter-from-class="-tw-translate-y-3 tw-opacity-0"
            enter-to-class="tw-translate-y-0 tw-opacity-100"
            leave-active-class="tw-transition-all tw-duration-150 tw-ease-in motion-reduce:tw-transition-none"
            leave-from-class="tw-translate-y-0 tw-opacity-100"
            leave-to-class="-tw-translate-y-2 tw-opacity-0"
        >
            <div v-if="isOpen" :class="contentClass">
                <slot />
            </div>
        </Transition>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';

const props = withDefaults(
    defineProps<{
        title?: string;
        subtext?: string;
        collapsible?: boolean;
        closed?: boolean;
        headerClass?: string;
        contentClass?: string;
    }>(),
    {
        closed: false,
    }
);

const isOpen = ref(!props.closed);

const toggle = (): void => {
    if (!props.collapsible) {
        return;
    }

    isOpen.value = !isOpen.value;
};
</script>
